import { AppConfig } from './app-config.type';

const checkRequiredEnvVariable = (variable: string): string => {
  const value = process.env[variable];
  if (value === undefined || value === null) {
    throw new Error(`Missing required environment variable: ${variable}`);
  }
  return value;
};

export const appConfig: AppConfig = {
  envName: checkRequiredEnvVariable('REACT_APP_ENV'),
  appUrl: checkRequiredEnvVariable('REACT_APP_URL'),
  apiUrl: checkRequiredEnvVariable('REACT_APP_GOLANG_API_URL'),
  oauth: {
    clientId: checkRequiredEnvVariable('REACT_APP_OAUTH_CLIENT_ID'),
  },
  configCatKey: checkRequiredEnvVariable('REACT_APP_CONFIG_CAT_SDK_KEY'),
  marianaAppUrl:
    process.env['REACT_APP_MARIANA_APP_URL'] ||
    'https://_tenant_.marianatek.com',
};
